module.exports = __webpack_public_path__ + "static/media/arrow.aa50316d.svg";